import React, { useState } from 'react';
import LegalDocumentation from './LegalDocumentation';

type Section = { title: string; content: string };

const sections: Section[] = [
  { title: 'Cookies', content: LegalDocumentation.cookies },
  { title: 'Disclaimer', content: LegalDocumentation.disclaimer },
  { title: 'Terms and Conditions', content: LegalDocumentation.termsAndConditions },
  { title: 'Privacy Policy', content: LegalDocumentation.privacy },
  { title: 'Acceptable Use', content: LegalDocumentation.acceptableUse },
];

const LegalItems: React.FC = () => {
  const [open, setOpen] = useState<string | null>(null);
  return (
    <main style={{ maxWidth: 880, margin: '0 auto', padding: '48px 24px 96px' }}>
      <h1 className="rr-display" style={{ fontSize: 40, marginBottom: 24 }}>
        The finer details
      </h1>
      <div
        className="rr-card"
        style={{ padding: 8 }}
      >
        {sections.map((section) => {
          const isOpen = open === section.title;
          return (
            <div
              key={section.title}
              style={{ borderBottom: '1px solid var(--rule-soft)' }}
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : section.title)}
                aria-expanded={isOpen}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  background: 'transparent',
                  border: 0,
                  padding: '16px 20px',
                  cursor: 'pointer',
                  fontFamily: 'var(--display)',
                  fontWeight: 500,
                  fontSize: 18,
                  color: 'var(--ink)',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                {section.title}
                <span style={{ color: 'var(--ink-faint)' }}>{isOpen ? '−' : '+'}</span>
              </button>
              {isOpen && (
                <div
                  style={{
                    padding: '0 20px 20px',
                    whiteSpace: 'pre-line',
                    fontFamily: 'var(--sans)',
                    fontSize: 14,
                    lineHeight: 1.6,
                    color: 'var(--ink-soft)',
                  }}
                >
                  {section.content}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </main>
  );
};

export default LegalItems;
